import Tooltip from '@material-ui/core/Tooltip';

import { withStyles } from '@material-ui/styles';

const HelpTooltip = withStyles((theme) => ({
  tooltip: {
    fontSize: '1rem'
  }
}))(Tooltip);

export default HelpTooltip;
